module.exports = "https://static.zego.com/_next/static/images/Backdrop-e87fd5805818388465cad334c060058a.svg";